import getSuggestionHighlight from "./get-suggestion-highlight";

describe("getSuggestionHighlight", () => {
    it("splits the text correctly", () => {
        expect(getSuggestionHighlight("lorem", "loremipsum")).toEqual(expect.arrayContaining(["lorem", "ipsum"]));
    });

    it("doesn't show a false match", () => {
        expect(getSuggestionHighlight("orem", "loremipsum")).toEqual(expect.arrayContaining(["", "loremipsum"]));
    });

    it("ignores upper or lower case", () => {
        expect(getSuggestionHighlight("LOrem", "loremipsum")).toEqual(expect.arrayContaining(["lorem", "ipsum"]));
    });

    it("handles empty input correctly", () => {
        expect(getSuggestionHighlight("", "loremipsum")).toEqual(expect.arrayContaining(["", "loremipsum"]));
    });
});
